module.exports = __webpack_public_path__ + "img/success.56244ced.svg";